import {Component, Input, OnChanges} from '@angular/core';
import {MatDialog} from '@angular/material/dialog';
import {SafeResourceUrl} from '@angular/platform-browser';
import {TeamRoleService} from '../../services/team-role/team-role.service';
import {GetTeamRoles} from '../../services/team-role/GetTeamRoles';
import {UserService} from '../../services/user/user.service';
import {GetUsers} from '../../services/user/GetUsers';
import {TeamMemberDetailsDialogComponent} from './team-member-details-dialog/team-member-details-dialog.component';
import {StringUtil} from '../../StringUtil';

@Component({
  selector: 'digires-team-member-bubble',
  templateUrl: './team-member-bubble.component.html',
  styleUrls: ['./team-member-bubble.component.scss']
})
export class TeamMemberBubbleComponent implements OnChanges {

  @Input() userId: string;
  @Input() roleId: string;
  @Input() type: 'BUBBLE' | 'TEXT' = 'BUBBLE';
  user: GetUsers;
  role: GetTeamRoles;
  initials: string;
  backgroundImage: SafeResourceUrl;

  constructor(
    private userService: UserService,
    private roleService: TeamRoleService,
    private dialog: MatDialog,
  ) { }

  ngOnChanges(): void {
    this.user = null;
    this.role = null;
    this.initials = null;
    if (this.userId && this.roleId) {
      this.userService.loadUserById(this.userId)
        .then(user => {
          this.user = user;
          this.initials = StringUtil.getInitialsFromName(this.user.fullName);
          if (this.type === 'BUBBLE') {
            // TODO: Disabled for now, might be enabled after Go-Live
            // this.userService.fetchUserPhoto(this.user.id)
            //   .then(picture => {
            //     this.backgroundImage = picture;
            //   });
          }
        })
        .catch(error => {
          console.error(error);
          this.user = {
            id: this.userId,
            fullName: `No User found for ID '${this.userId}'`,
            department: null,
            email: null,
            phone: null,
            mobile: null,
          };
        });
      this.roleService.fetchTeamRoleById(this.roleId)
        .then(role => {
          this.role = role;
        });
    }
  }

  openUserDialog() {
    this.dialog.open(TeamMemberDetailsDialogComponent,
      {
        hasBackdrop: true,
        data: {
          user: this.user,
          role: this.role,
          userPicture: this.backgroundImage,
          userPictureEnabled: this.type === 'BUBBLE',
        }
      });
  }

}
